import { servidor } from "../servidor";
/**
 * Crea un nuevo producto en el sistema a través del endpoint `/movilabs/createProduct`.
 *
 * @async
 * @function createProduct
 * @param {Object} item - Objeto con los datos del producto a crear.
 * @param {string} store - Identificador de la tienda que realiza la operación.
 * @param {string} branch - Identificador de la sucursal relacionada con el producto.
 * @param {string} responsable - Identificador del usuario responsable de la creación.
 * @returns {Promise<string>} Mensaje de éxito devuelto por el servidor.
 * @throws {Error} Si la petición falla por un error de red, status HTTP inesperado o error del servidor.
 */

export const createProduct = async (item, store, branch, responsable) => {
  try {
    const response = await servidor.post("/movilabs/createProduct", {
      item,
      store,
      branch,
      responsable
    });
    if (response.status !== 200) {
      throw new Error(`Error: Received status code ${response.status}`);
    }
    // console.log('response', response.data);
    return response.data.message;
  } catch (error) {
    console.error("Error fetching create products data:", error);

    // Si el servidor responde con un error (como 400 o 500)
    if (error.response && error.response.data) {
      const serverMsg = error.response.data.msg || error.response.data.error;
      throw new Error(serverMsg || "Error desconocido del servidor.");
    }

    // Error de red u otra excepción
    throw new Error("Servicio no disponible. Inténtalo más tarde.");
  }
};
